export default "__VITE_ASSET__b7d86f32__"